import { Metadata, RpcError } from "grpc-web";
import { AuthenticationEndpointClient } from "../repository/Sarafa/AuthenticationServiceClientPb";
import { MessageResponse } from "../repository/Sarafa/common_pb";
import { getCurrentLanguage } from "./Helpers";
import i18n from "./i18n";
import {
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    HttpTransportType,
} from "@microsoft/signalr";
import { getUsername, API_URL, getHeaders as getAuthServiceHeader, refreshSession as refreshAuthService } from "./Api";
import { AuthenticateClientReply, AuthenticateClientRequest } from "../repository/dimensions/thirdparty_pb";
import { ThirdPartyEndpointClient } from "../repository/dimensions/ThirdpartyServiceClientPb";

export const SARAFA_API_URL = "https://sarafaclientsportalprod.blackdune-4ce1bdf5.westeurope.azurecontainerapps.io";//"https://localhost:5408";
export const SARAFA_TRADING_API_URL = "https://sarafaclientportaltradingprod.lemonpebble-e42890be.germanywestcentral.azurecontainerapps.io"//"https://sarafaclientportaltradingprod.lemonpebble-e42890be.germanywestcentral.azurecontainerapps.io"; ///"http://192.168.1.117:5408";//"https://dimensionsclientportal.azurewebsites.net";//"https://localhost:5101";
export const ORGANIZATION_LOGO_URL = "https://devpoint.blob.core.windows.net/sarafaorgslogos/"; //"https://localhost:5301";

const client = new ThirdPartyEndpointClient(API_URL, null, null);

export interface ApiMessage {
    body: string,
    title: string,
    type: number,
    data: any,
}

export interface APIRequest<T> {
    body: T,
    headers?: {},
    metadata?: any,
}

export interface APIResponse<T> {
    metadata?: any,
    response: T,
}



export const toApiMessage = (res: any): ApiMessage => {
    let type = Number(res.type?.value)
    if (!Number.isNaN(type)) {
        return { body: decodeURIComponent(res.body?.value), title: decodeURIComponent(res.title?.value), type: type } as ApiMessage;
    } else {
        return { data: decodeURIComponent(res?.data ?? ""), body: decodeURIComponent(res.body), title: decodeURIComponent(res.title), type: Number(res.type) } as ApiMessage;
    }
}


export const getCurrentLng = () => {

    var lang = getCurrentLanguage();
    if (lang == 'ar')
        lang += "-LY"
    else
        lang += "-US"

    return lang;
};


export const getHeaders = () => {

    var auth: Record<string, any> = { "Accept-Language": getCurrentLng(), "Timezone": (((new Date()).getTimezoneOffset()) * -1) + ""   };
    try {
        auth = {
            ...auth,
            "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
        }
    } catch {

    }
    return auth;
};


export const refreshSession = async (): Promise<boolean> => {
    let username = undefined;
    try {
        var session = getSession();
        var req = new AuthenticateClientRequest();
        req.setUsername(session?.username?.value)
        var r = await client.authenticateClient(req, getAuthServiceHeader() ?? {});
        var response = r.toObject();
        if (response?.success) {
            saveSession(response?.success)
            return true;
        }
        return false;



    } catch (e) {
        try {
            let message = toApiMessage((e as RpcError).metadata);
            if (message.data == 401) {
                var isSessionRefreshed = await refreshAuthService();
                if (isSessionRefreshed) {
                    return await refreshSession();
                }
            }
        }catch(ex){
            throw ex;
        }
        throw e;
    }
}


let currentSession: any = localStorage.getItem('accountSession');

export const saveSession = (session: any) => {
    currentSession = JSON.stringify(session)
    //console.log(currentSession)
    localStorage.setItem('accountSession', currentSession)
};


export const getSession = () => {
    var i = currentSession;
    if (i) {
        var c = JSON.parse(i) as any;
        if (c.accesstoken) {
            return c;
        }
    }
    clearSession();
    throw null;
};



export const clearSession = () => {
    currentSession = undefined;
    localStorage.removeItem('accountSession');

};

/** Module‑level variable that holds the single instance */
let feedConnection: any = null;

/**
 * Returns a started HubConnection.
 * If a connection already exists and is still connected, it is reused (singleton).
 * Otherwise a new connection is built and started.
 */
export const getFeedConnection = async (): Promise<HubConnection | null> => {
    // Re‑use the existing live connection

    if (
        feedConnection &&
        feedConnection.state === HubConnectionState.Connected
    ) {
        return feedConnection;
    }


    // Helper that actually builds & starts the connection
    const buildConnection = async (): Promise<HubConnection | null> => {
        try {
            const connection = new HubConnectionBuilder()
                .withUrl(`${SARAFA_TRADING_API_URL}/feed`, {
                    transport: HttpTransportType.WebSockets,
                    accessTokenFactory: () =>
                        getSession().accesstoken?.token?.value ?? "",
                })
                .withAutomaticReconnect()
                .build();

            await connection.start();

            return connection;
        } catch (err: any) {
            // Token expired? Try once after refreshing the session
            if (err.message?.includes("Status code '401'")) {
                const refreshed = await refreshSession();
                if (refreshed) {
                    return await buildConnection();
                }
            }
            return null;
            // Re‑throw so callers can handle/reject as they wish
        }
    };

    feedConnection = await buildConnection();

    return feedConnection;
};
export const terminateFeedConnection = async (): Promise<void> => {
    // Re‑use the existing live connection
    if (feedConnection == null || feedConnection == undefined) {
        return;
    }
    feedConnection.off()
    await feedConnection.stop();

    feedConnection = null;

    // Helper that actually builds & starts the connection


};

